import { render } from "./Sala3Es.vue?vue&type=template&id=50fc4aa4"
import script from "./Sala3Es.vue?vue&type=script&lang=js"
export * from "./Sala3Es.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\marco\\Desktop\\archeo-guida-smart\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__